module.exports = __webpack_public_path__ + "static/media/undraw_dev_focus_b9xo.fa75134c.svg";